import Navbar from "../components/Navbar";
import Hero from "../components/Hero";
import WhyChoose from "../components/WhyChoose";
import Services from "../components/Services";
import Conditions from "../components/Conditions";
import Areas from "../components/Areas";
import About from "../components/About";
import Testimonials from "../components/Testimonials";
import ContactSection from "../components/ContactSection";
import Footer from "../components/Footer";

export default function Home() {
  return (
    <div data-testid="home-page" className="min-h-screen bg-[#1B0B3A] text-[#F5F2FF]">
      <Navbar />
      <main>
        <Hero />
        <WhyChoose />
        <Services />
        <Conditions />
        <Areas />
        <About />
        <Testimonials />
        <ContactSection />
      </main>
      <Footer />
    </div>
  );
}
